module.exports = __webpack_public_path__ + "static/razogrev-6ee19278c5f7f70b18d7846f630bf661.webp";